import React from "react";

import "./CircularLoader.scss";

const CircularLoader = () => {
	return (
		<svg className="circular-loader" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle className="circular-loader-path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
		</svg>
	);
};

export default CircularLoader;



// WEBPACK FOOTER //
// ./src/shared/components/CircularLoader/CircularLoader.jsx